export default {
  functional: true,

  render: function (createElement, {children, props, parent}) {
    const Velocity = parent.$velocity
    let height = 0
    let duration = props.duration ? props.duration : 1000
    let easing = props.easing ? props.easing : 'easeInSine'
    let marginTop = props.marginTop ? props.marginTop : 0

    var data = {
      props: {
        name: 'grow-transition',
        mode: 'out-in',
        duration: 1000,
      },
      on: {
        beforeEnter: function (el) {
          const clone = el.cloneNode(true)

          Velocity(el, 'stop', true)

          el.style.height = 0
          el.style.overflow = 'hidden'
          clone.style.width = el.style.width
          clone.style.visibility = 'hidden'
          clone.style.removeProperty('display')

          el.parentNode.appendChild(clone)
          height = clone.clientHeight
          el.parentNode.removeChild(clone)
        },

        enter: function (el, done) {
          Velocity(el,
            { height: height, translateY: marginTop },
            {
              duration: duration,
              easing: easing,
              complete: () => done(),
            }
          )
        },

        afterEnter: function (el) {
          el.style.removeProperty('height')
          el.style.removeProperty('overflow')
        },

        enterCancelled: function (el) {
          Velocity(el, 'stop', true)
          el.style.removeProperty('height')
          el.style.removeProperty('overflow')
        },

        beforeLeave: function (el) {
          el.style.overflow = 'hidden'
        },

        leave: function (el, done) {
          Velocity(el,
            { height: 0, translateY: 0 },
            {
              duration: duration,
              complete: () => done(),
            }
          )
        },

        afterLeave: function (el) {
          el.style.removeProperty('height')
          el.style.removeProperty('overflow')
        },

        leaveCancelled: function (el) {
          Velocity(el, 'stop', true)
          el.style.removeProperty('height')
          el.style.removeProperty('overflow')
        },
      },
    }
    return createElement('transition', data, children)
  },
}
